import React, { createContext, useContext } from 'react';
import { useBreakpointValue } from '@chakra-ui/react';

interface BreakpointContextProps {
  isMobile: boolean;
}

const BreakpointContext = createContext<BreakpointContextProps | undefined>(
  undefined
);

export const BreakpointProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const isMobile = useBreakpointValue({ base: true, lg: false }) || false;

  return (
    <BreakpointContext.Provider value={{ isMobile }}>
      {children}
    </BreakpointContext.Provider>
  );
};

export const useBreakpoint = () => {
  const context = useContext(BreakpointContext);
  if (context === undefined) {
    throw new Error('useBreakpoint must be used within a BreakpointProvider');
  }
  return context;
};
